import { store } from '../store.js';

export default class BookObject {
  static objectDefinition(
    deliveryOrTakeAway,
    userInputs,
    eventDetails,
    shoppingCart,
    datesAndTimes,
    deliveryOption,
    remark,
    selectedLocation) {
    console.log("Brian datesAndTimes", datesAndTimes);

    const sendingProducts = {};
    const data = {
      StartBatch: {
        StartDate: datesAndTimes.StartDate.split('-').reverse().join('-'),
        StartTime: datesAndTimes.StartTime.StartTime,
        EndTime: datesAndTimes.StartTime.EndTime,
      },
      EndBatch: {
        StartTime: '',
        EndTime: '',
        EndDate: '',
      },
      StartBatchGroupId: datesAndTimes.StartTime.BatchGroupId,
      LocationId: selectedLocation.LocationId,
      LanguageTagId: store.getters.getUserLanguage,
      AddressInfo: {
        Name: `${userInputs[11]} ${userInputs[12]}`,
        PhoneNumber: userInputs[19],
        Latitude: userInputs.Latitude === undefined ? -200 : userInputs.Latitude,
        Longitude: userInputs.Longitude === undefined ? -200 : userInputs.Longitude,
      },
      Note: remark,
      EventId: Number(eventDetails.EventId),
    };
    if (datesAndTimes.EndTime !== undefined) data.EndBatchGroupId = datesAndTimes.EndTime.BatchGroupId;
    if (eventDetails.Type === 'OrderEvent'
      || eventDetails.Type === 'Rental') {
      data.AddressInfo.City = userInputs[17];
      data.AddressInfo.Street = userInputs[14];
      data.AddressInfo.Nr = userInputs[15];
      Object.values(shoppingCart).forEach((product) => {
        if (product.Amount > '0') {
          if (product.hasOwnProperty(('Items'))) {
            if (sendingProducts.hasOwnProperty(product.ParentId)) {
              sendingProducts[product.ParentId][product.Items[0].Id] = Number(product.Amount);
            } else {
              sendingProducts[product.ParentId] = { [product.Items[0].Id]: Number(product.Amount) };
            }
          } else if (sendingProducts.hasOwnProperty(product.ParentId)) {
            sendingProducts[product.ParentId][product.Id] = Number(product.Amount);
          } else {
            sendingProducts[product.ParentId] = { [product.Id]: Number(product.Amount) };
          }
        }
      })
      data.Products = sendingProducts;
    } else {
      Object.values(shoppingCart).forEach((ticket) => {
        if (ticket.Amount > '0') {
          Object.assign(
            sendingProducts,
            { [ticket.Id]: Number(ticket.Amount) },
          );
        }
      });
      data.Tickets = sendingProducts;
    }
    if (eventDetails.Type !== 'OrderEvent') {
      data.EndBatch = {
        EndDate: datesAndTimes.EndDate.split('-').reverse().join('-'),
        StartTime: datesAndTimes.EndTime.StartTime,
        EndTime: datesAndTimes.EndTime.EndTime,
      };
    } else {
      if (deliveryOrTakeAway === 'Delivery') data.DeliveryOption = Number(deliveryOption.Id);
      data.OrderType = deliveryOrTakeAway;
    }
    return data;
  }
}
